import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,863.966118 L1920,1694.08376 C1920,1818.31906 1818.35294,1919.96612 1694.11765,1919.96612 C1569.88235,1919.96612 1468.23529,1818.31906 1468.23529,1694.08376 L1468.23529,1694.08376 L1468.23529,1125.98965 C1655.71765,1110.17788 1818.35294,1009.66024 1920,863.966118 L1920,863.966118 Z M508.235294,-2.5243549e-29 C706.108235,-2.5243549e-29 876.084706,114.861176 960,280.207059 C1043.91529,114.861176 1213.89176,-2.5243549e-29 1411.76471,-2.5243549e-29 L1411.76471,-2.5243549e-29 L1920,-2.5243549e-29 L1920,508.235294 C1920,788.442353 1691.97176,1016.47059 1411.76471,1016.47059 L1411.76471,1016.47059 L508.235294,1016.47059 C228.028235,1016.47059 5.04870979e-29,788.442353 5.04870979e-29,508.235294 L5.04870979e-29,508.235294 L5.04870979e-29,-2.5243549e-29 Z M1694.11765,338.823529 L1411.76471,338.823529 C1256.01882,338.823529 1129.41176,465.543529 1129.41176,621.176471 L1129.41176,621.176471 L1129.41176,677.647059 L1411.76471,677.647059 C1567.51059,677.647059 1694.11765,550.927059 1694.11765,395.294118 L1694.11765,395.294118 L1694.11765,338.823529 Z M508.235294,338.823529 L225.882353,338.823529 L225.882353,395.294118 C225.882353,550.927059 352.489412,677.647059 508.235294,677.647059 L508.235294,677.647059 L790.588235,677.647059 L790.588235,621.176471 C790.588235,465.543529 663.981176,338.823529 508.235294,338.823529 L508.235294,338.823529 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMasqueradeSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMasqueradeSolid, _Component);

  var _super = _createSuper(IconMasqueradeSolid);

  function IconMasqueradeSolid() {
    _classCallCheck(this, IconMasqueradeSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMasqueradeSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMasquerade",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMasqueradeSolid.displayName = "IconMasqueradeSolid";
  return IconMasqueradeSolid;
}(Component);

IconMasqueradeSolid.glyphName = 'masquerade';
IconMasqueradeSolid.variant = 'Solid';
IconMasqueradeSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMasqueradeSolid;
export { IconMasqueradeSolid };